import React from 'react'

import {
  BooleanField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  isActive: { id: 'isActive', label: 'Active', ordering: 'is_active', renderer: BooleanField },
}

export const ClientListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title="Clients"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
